<template>
	<div class="vx-row">

		

		
		<!-- MULTIPLE COLUMNS-->
		<div class="vx-col w-full mb-base">
			<vx-card title="Ajouter un agent">
			
        <div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<vs-input label-placeholder="Nom" v-model="dataLastname" class="mt-5 w-full" name="name" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input label-placeholder="Prénom" v-model="dataFirstname" class="mt-5 w-full" name="firstname" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('firstname')">{{ errors.first('firstname') }}</span>
					</div>
				</div>

				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input label-placeholder="Téléphone" v-model="dataPhone" class="mt-5 w-full" name="phone" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<vs-input label-placeholder="Email" v-model="dataEmail" class="mt-5 w-full" name="email" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
          <br>
           <datepicker v-model="dataBirthday"
          placeholder="Choisir la date de naissance"
          name="birthday"
          :language="languages[language]"
          format="yyyy-MM-dd"
          v-validate="'required'"
        ></datepicker>
        <span
          class="text-danger text-sm"
          v-show="errors.has('birthday')">{{ errors.first('birthday') }}</span>
						
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-6">
					<br>
          <datepicker v-model="dataHiredAt"
            placeholder="Choisir la date d'embauche"
            name="hired_at"
            :language="languages[language]"
            format="yyyy-MM-dd"
            v-validate="'required'"
          ></datepicker>
          <span
            class="text-danger text-sm"
            v-show="errors.has('hired_at')">{{ errors.first('hired_at') }}</span>
            </div>
          </div>
       <div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<vs-select placeholder="Choisir la fonction"
          v-model="dataFonction"
          label="Fonction"
          class="mt-5 w-full"
          name="fonction"
          v-validate="'required'">
          <vs-select-item
            :key="item.value"
            :value="item.id"
            :text="item.name"
            v-for="item in fonction_choices"
          />
        </vs-select>
        <span
          class="text-danger text-sm"
          v-show="errors.has('fonction')">{{ errors.first('fonction') }}</span>
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select placeholder="Choisir l'équipe" 
             v-model="dataTeam" label="Equipe" class="mt-5 w-full" name="team" v-validate="'required'">
          <vs-select-item
            :key="item.value"
            :value="item.id"
            :text="item.name"
            v-for="item in team_choices"
          />
        </vs-select>
        <span
          class="text-danger text-sm"
          v-show="errors.has('team')">{{ errors.first('team') }}</span>
					</div>
				</div>
				<!--div class="vx-row">
					<div class="vx-col w-full mb-6">
						<vs-checkbox class="inline-flex" v-model="check7">Remember Me</vs-checkbox>
					</div>
				</div-->
				<div class="vx-row">
					<div class="vx-col w-full">
						<vs-button class="mr-3 mb-2" @click="submitData" >Valider</vs-button>
						<vs-button color="warning" type="border" class="mb-2" @click="input25 = input26 = input27 = input28 = input29 = input30 = ''; check7 = false;">Reset</vs-button>
					</div>
				</div>
        <template slot="codeContainer">
&lt;template&gt;
  &lt;div class=&quot;vx-row&quot;&gt;
    &lt;div class=&quot;vx-col sm:w-1/2 w-full mb-2&quot;&gt;
      &lt;vs-input class=&quot;w-full&quot; label-placeholder=&quot;First Name&quot; v-model=&quot;input25&quot; /&gt;
    &lt;/div&gt;
    &lt;div class=&quot;vx-col sm:w-1/2 w-full mb-2&quot;&gt;
      &lt;vs-input class=&quot;w-full&quot; label-placeholder=&quot;Last Name&quot; v-model=&quot;input26&quot; /&gt;
    &lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;vx-row&quot;&gt;
    &lt;div class=&quot;vx-col sm:w-1/2 w-full mb-2&quot;&gt;
      &lt;vs-input class=&quot;w-full&quot; label-placeholder=&quot;City&quot; v-model=&quot;input27&quot; /&gt;
    &lt;/div&gt;
    &lt;div class=&quot;vx-col sm:w-1/2 w-full mb-2&quot;&gt;
      &lt;vs-input class=&quot;w-full&quot; label-placeholder=&quot;Country&quot; v-model=&quot;input28&quot; /&gt;
    &lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;vx-row&quot;&gt;
    &lt;div class=&quot;vx-col sm:w-1/2 w-full mb-2&quot;&gt;
      &lt;vs-input class=&quot;w-full&quot; label-placeholder=&quot;Company&quot; v-model=&quot;input29&quot; /&gt;
    &lt;/div&gt;
    &lt;div class=&quot;vx-col sm:w-1/2 w-full mb-6&quot;&gt;
      &lt;vs-input type=&quot;email&quot; class=&quot;w-full&quot; label-placeholder=&quot;Email&quot; v-model=&quot;input30&quot; /&gt;
    &lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;vx-row&quot;&gt;
    &lt;div class=&quot;vx-col w-full mb-6&quot;&gt;
      &lt;vs-checkbox class=&quot;inline-flex&quot; v-model=&quot;check7&quot;&gt;Remember Me&lt;/vs-checkbox&gt;
    &lt;/div&gt;
  &lt;/div&gt;
  &lt;div class=&quot;vx-row&quot;&gt;
    &lt;div class=&quot;vx-col w-full&quot;&gt;
      &lt;vs-button class=&quot;mr-3 mb-2&quot;&gt;Submit&lt;/vs-button&gt;
      &lt;vs-button color=&quot;warning&quot; type=&quot;border&quot; class=&quot;mb-2&quot; @click=&quot;input25 = input26 = input27 = input28 = input29 = input30 = ''; check7 = false;&quot;&gt;Reset&lt;/vs-button&gt;
    &lt;/div&gt;
  &lt;/div&gt;
&lt;/template&gt;
        </template>
			</vx-card>
		</div>
	</div>
</template>

<script>

import axios from "@/axios.js";

import Datepicker from "vuejs-datepicker";

import * as lang from "vuejs-datepicker/src/locale";

export default{
  
	data() {
		return {
      dataId: null,
      language: "fr",
      languages: lang,
      dataFirstname: "elom",
      dataLastname: "kodjo",
      dataFonction: null,
      dataTeam: null,
      dataPhone: "22996959897",
      dataBirthday: null,
      dataHiredAt: null,
      dataRole: 3,
      dataEmail: "salut@roger.com",
      team_choices: [
       
      ],
         fonction_choices: [
       
      ]
		}
  },
  components:{
    Datepicker
  },
	methods: {
    getDatepickerValue(datepick) {
      var date = datepick.getDate();
      var month = datepick.getMonth() + 1;
      var year = datepick.getFullYear();
      if (date < 10) {
        date = "0" + date;
      }
      if (month < 10) {
        month = "0" + month;
      }

      var result = year + "-" + month + "-" + date;

      return result;
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        console.log('mix');		  
        if (result) {
          const obj = {
            id: this.dataId,
            firstname: this.dataFirstname,
            lastname: this.dataLastname,
            role: this.dataRole,
            fonction: this.dataFonction,
            team: this.dataTeam,
            email: this.dataEmail,
            phone: this.dataPhone,
            hired_at: this.getDatepickerValue(this.dataHiredAt),
            birthday: this.getDatepickerValue(this.dataBirthday)

            //price: this.dataEmail
          };

          axios.post('/users', {firstname: obj.firstname,lastname: obj.lastname,email: obj.email,
          phone: obj.phone,  birthday: obj.birthday,  hired_at: obj.hired_at, role: obj.role,
          fonction: obj.fonction,team: obj.team, manager:false, channel:true})
          .then((response) => {         
          
            console.log('épassé', response);
          
            this.$vs.notify({
              title: 'Succès',
              text: 'Succès',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'})
          })
          .catch((error) => { 

            console.log('aaaaaaaaaaaaa');

            console.log(error);
            
              //this.$vs.loading.close()
              this.$vs.notify({
                title: 'Erreur',
                text: error.response.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            
            })
          
            
            
            
          })     
        }   
      })

    }  
  },
mounted() {
    axios.get("/roles").then(response => {
      this.role_choices = response.data.data;

      
      
      
      
      //console.log(response.data.data)
    }),
      axios.get("/functions").then(response => {
        this.fonction_choices = response.data.data;
        //console.log('ok');
        //console.log(response.data.data)
      }),
      axios.get("/teams").then(response => {
        this.team_choices = response.data.data;
        //console.log(response.data.data)
      })
    
  }
	
}
</script>
